import { useMemo } from 'react';
import getEventsDict from '@sdk/schedule/helpers/getEventsDict';
import type { EventType } from '@sdk/schedule/types/EventType';
import type { EventDict } from '@sdk/schedule/helpers/getEventsDict';

const useAllEvents = (allEvents: EventType[]): EventDict =>
  useMemo(() => getEventsDict(allEvents), [allEvents]);

export default useAllEvents;
